import React from 'react';
import { gnssObstacleCounts } from '../utils/gnssResultSegments';

export default function GnssCategoryComparison({ results }) {
  const groups = new Map();
  for (const result of results || []) {
    const input = result.input || {};
    const key = JSON.stringify([input.id, input.airport_code, input.runway_designator, input.approach_id]);
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(result);
  }
  const cell = { padding: '5px 8px', border: '1px solid #ddd', textAlign: 'left' };
  const altitude = value => Number.isFinite(Number(value)) && value != null ? Number(value).toFixed(1) : '—';
  return [...groups.entries()].filter(([, categories]) => categories.length > 1).map(([key, categories]) => {
    const input = categories[0].input;
    return <div key={key} style={{ marginBottom: 12, background: '#fff', padding: 10, borderRadius: 4 }}>
      <b>{input.airport_code} / RWY {input.runway_designator} – {input.approach_id} ({input.approach_type})</b>
      <div style={{ overflowX: 'auto', marginTop: 6 }}>
        <table style={{ borderCollapse: 'collapse', width: '100%', fontSize: 12 }}>
          <thead><tr style={{ background: '#bbdefb' }}>
            {['Aircraft cat', 'Used OCA (ft)', 'Computed max OCA (ft)', 'Computed max MOCA (ft)', 'Obstacles assessed', 'Critical', 'Status'].map(label =>
              <th key={label} style={cell}>{label}</th>)}
          </tr></thead>
          <tbody>{categories.map((result, index) => {
            const counts = gnssObstacleCounts(result);
            return <tr key={`${result.input.evaluation_id}-${index}`}>
            <td style={cell}><b>{result.input.aircraft_category}</b></td>
            <td style={cell}>{altitude(result.input.oca == null ? null
              : result.input.oca_unit === 'm' ? Number(result.input.oca) / 0.3048 : result.input.oca)}</td>
            <td style={cell}>{altitude(result.summary?.maxOcaFt)}</td>
            <td style={cell}>{altitude(result.summary?.maxMocaFt)}</td>
            <td style={cell}>{result.input.error ? '—' : counts.obstaclesAssessed}</td>
            <td style={cell}>{result.input.error ? '—' : counts.criticalObstacles}</td>
            <td style={{ ...cell, color: result.input.error || counts.criticalObstacles > 0 ? '#b71c1c' : result.manualReviewRequired ? '#555' : '#2e7d32' }}>
              {result.input.error || (result.manualReviewRequired ? 'Preliminary – manual review' : counts.criticalObstacles > 0 ? 'Impact' : 'No impact')}
            </td>
          </tr>;
          })}</tbody>
        </table>
      </div>
    </div>;
  });
}
